import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
export default {
  components: {
    PageNavBackLayoutCpt
  }
};